import { useMutation, useQueryClient } from '@tanstack/react-query';
import Quote, { mockPayload } from 'shared/api/assurant/quote';
import { useContext } from 'react';
import { FormDataContext } from 'app/providers/formValues/lib/FormDataContext';
import { QuoteResponse } from 'shared/api/assurant/quoteResponseTypes';
import { AxiosResponse } from 'axios';
import { MovedTenantResponse } from 'shared/api/assurant/tenantResponse';
import { isRecoverableQuoteResponseMessage } from 'shared/utils/isRecoverableQuoteResponseMessage';

export const useMutationQuery = () => {
	const queryClient = useQueryClient()
	const { setInitialPayloadData } = useContext(FormDataContext);
	return useMutation({
		mutationFn: Quote.postRentersQuote,
		onSuccess: data => {
			queryClient.setQueryData(['quoteData'], data.data)
			const responseMessage = data.data.transactionDetails.responseMessage
			if (!data.data.transactionDetails.workItemId && responseMessage && !isRecoverableQuoteResponseMessage(responseMessage)) {
				throw new Error(responseMessage);
			}
		},
		onError: error => {
			console.log('Error getting quote', error);
			setInitialPayloadData(mockPayload)
		}
	})
}

export const useGetTenant = () => {
	const queryClient = useQueryClient()
	return useMutation({
		mutationFn: Quote.getTenantData,
		onSuccess: (data: AxiosResponse<MovedTenantResponse>) => {
			queryClient.setQueryData(['newTenantPayload'], data.data)
		},
		onError: error => {
			console.log('something goes wrong', error);
		}
	})
}
export const useCreateTenant = () => {
	return useMutation({
		mutationFn: Quote.createTenant,
	})
}
export const useQuoteQuery = () => {
	const client = useQueryClient()
	return client.getQueryData<QuoteResponse>(['quoteData'])
}
